<template>
  <div>
    <div class="row mt-3 mb-2">
      <div class="col-sm-12">
        <div class="float-sm-end d-flex" style="justify-content: end">
          <div class="me-2">
            <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newTask()">
              <i class="mdi mdi-plus mr-1"></i> Nova ação
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table table-centered table-hover">
            <thead>
              <tr>
                <th width="20%">Data</th>
                <th width="40%">Tarefa</th>
                <th width="10%">Lista</th>
                <th width="10%">Status destino</th>
                <th width="10%">Status</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="list in tasks" :key="list.id">
                <td>{{ list.created_at }}</td>
                <td>{{ list.name }}</td>
                <td>{{ list.type_contact }} ({{ list.qty_contacts }})</td>
                <td>
                  <span class="badge badge-info font-size-12 p-2">
                    {{ list.target_status_label }}
                  </span>
                </td>
                <td>
                  <span
                    :class="list.classStatus"
                    class="badge font-size-12 p-2" style="min-width: 120px">
                      {{ list.statusLabel }}
                  </span>
                </td>
                <td>
                  <button v-if="user.role === 'Admin'" type="button" @click="detailLog(list.id)" class="link btn btn-outline-primary btn-sm"><i class="bx bx-search"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-form ref="formChangeStatus" @created="updateList"></modal-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ModalForm from './Form'

export default {
  components: {
    ModalForm
  },
  data () {
    return {
      loading: true,
      modalForm: false,
      timeout: 10000,
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 5
    }
  },
  mounted () {
    this.updateList()
    this.timeout = setInterval(() => {
      this.updateList()
    }, 10000)
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  methods: {
    ...mapActions('taskChangeStatus', {
      getAll: 'getAll'
    }),
    cancelAutoUpdate () {
      clearInterval(this.timeout)
    },
    newTask () {
      this.$refs.formChangeStatus.open()
    },
    detailLog (id) {
      if (this.user.role === 'Admin') {
        this.$router.push({
          name: 'task-change-status-details',
          params: { id: id }
        })
      }
    },
    getReport () {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loader = this.$loading.show()
      this.getAll(this.params).then(() => {
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loader.hide()
      }).catch(error => {
        console.log(error)
        loader.hide()
      })
    },
    updateList () {
      this.getReport()
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('taskChangeStatus', ['tasks', 'pagination']),
    rows () {
      return this.pagination.total
    }
  }
}
</script>
<style scoped>
.float-sm-end { float: right }
</style>
